import { graphql } from "gatsby";
import React from "react";

import { Party } from "../components";
import { default as DefaultLayout } from "../layouts";

// TODO: use https://github.com/dotansimha/graphql-code-generator
// to generate all types from graphQL schema
interface IndexPageProps {
    data: {
        site: {
            siteMetadata: {
                title: string;
            };
        };
    };
}

export default class extends React.Component<IndexPageProps> {
    public readonly displayName = "IndexPage";

    public render() {
        return (
            <DefaultLayout>
                <Party />
            </DefaultLayout>
        );
    }
}

export const query = graphql`
    query {
        site {
            siteMetadata {
                title
            }
        }
    }
`;
